import { useQuery, useQueryClient } from "@tanstack/react-query";
import { execQuery, queries } from "../graphql";
import { User } from "../API";

function useCurrentUser() {
  const queryClient = useQueryClient();

  useQuery(
    ["user", "currentUser"],
    () =>
      execQuery(queries.getCurrentUser).then(
        (res) => res.data?.getCurrentUser || null,
      ),
    {
      staleTime: Infinity,
    },
  );
  return queryClient.getQueryData(["user", "currentUser"]) as User | null;
}

export default useCurrentUser;
